import React from 'react'
import './footer.css'

const Footer = () => {
    return (
        <div id="footerContainer">
            <hr id="footerBorder"/>
            <footer>
                &copy; Lauren Cochran | Design by her awesome brother
                <br/>
                <br/>
                <a href="https://cochranc.com">cochranc.com</a>
                <br/>
            </footer>
        </div>
    )
}

export default Footer
